import { Injectable } from '@angular/core';
import { PasFeature } from '@ddt-web/data-service';
import { AssetResolveResponse, PasPortfolioPosition } from '@ddt-web/pas';

/**
 * Service to be extended if any new post processing is required in WWE API calls.
 */
@Injectable()
export abstract class PasPostProcessingService {
	// empty service to extend

	public abstract process(
		portfoliosToLoad: PasPortfolioPosition[],
		filteredIds?: string[],
		positionDataFromApiCall?: AssetResolveResponse,
		feature?: PasFeature,
		store?: string
	): void;
}
